import React, { useState, useEffect, useMemo, useRef } from 'react';
import {
  Container,
  Input,
  Button,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';
import { connect } from 'react-redux';
import VenteChargeEdit from '../vente_list/VenteChargeEdit';
import { ISummaryChargeTable, IAuthReduxProps } from '../../types/interfaces';
import { getVenteByIdPromise } from '../../flux/actions/venteActions';

import TableContainer from "../tables_manager/TableContainer"
import { SelectColumnFilter, NumberRangeColumnFilter, DateRangeColumnFilter } from '../tables_manager/filters';
import EditableCell from "../tables_manager/EditableCell";
import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faClipboard, faExternalLinkAlt, faEye, faFileInvoice, faListOl, faPen, faPhone, faTrash } from '@fortawesome/free-solid-svg-icons'
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import { E_ERROR } from '../../types/errors';
import { useAlert } from "react-alert";
import moment from "moment";
import LinesEllipsis from 'react-lines-ellipsis'
import ReactTooltip from 'react-tooltip';
import PDFLink from '../pdf/PDFLink';
import { PRIVILEGE } from '../../types/privileges';

const SummaryChargeTable = ({ 
  ventesData,
  setFilteredRows,
  selectedProjet,
  allAssociationsShown,
  auth
 }: ISummaryChargeTable) => {
  const skipResetRef = useRef(false);
  const history = useHistory();
  const alert = useAlert();
  
  const viewDetailsPage = (e, userId) => {
    if(userId !== null && userId !== undefined && selectedProjet?.id){
      if (e.ctrlKey){
        window.open(`/ventes_par_charge/${selectedProjet.id === "ALL" ? -1 : selectedProjet.id}/${userId}`, '_blank');
        return;
      }
      history.push({ pathname: `/ventes_par_charge/${selectedProjet.id === "ALL" ? -1 : selectedProjet.id}/${userId}` })
    }
    else
      alert.error(E_ERROR.NO_USER_WITH_THIS_ID)
  }

  const columns = useMemo(
    () => [
      {
        Header: "Détails",
        className: "text-center",
        Cell: ({ row: {original} }) => (
            <Container className="actionsContainer">
                <button className="btn btn-info btn-rounded btn-sm my-0 waves-effect waves-light"
                  onClick={(e) => viewDetailsPage(e, original.id)}
                  title="Plus de détails (CTRL+Clic pour l'ouvrir dans une nouvelle page)">
                  <FontAwesomeIcon icon={faListOl} />
                </button>
            </Container>
        ),
        disableSortBy: true,
      },
      {
        Header: "Chargé des biens",
        accessor: "username",
        Cell: ({ value }) => value || "-"
      },
      // ...(showProjectColumn || true ? [{
      //   Header: "Projet",
      //   accessor: "PROJET",
      // }] : []),
      {
        Header: "Nombre de ventes",
        id: "Nombre de ventes",
        accessor: row => row.chargeVentes?.length || 0,
        customExportDisplay: `$.chargeVentes ? $.chargeVentes.length : 0`,
        Filter: NumberRangeColumnFilter,
        filter: 'between',
      },
      {
        Header: "Somme des Prix Net",
        id: "Somme des Prix Net",
        accessor: row => row.chargeVentes?.reduce((e, t) => e + ((t.isAssLine ? t.PRIX_VENTE : t.PRIX_NET) || 0), 0) || 0,
        customExportDisplay: `$.chargeVentes ? $.chargeVentes.reduce((e, t) => e + ((t.isAssLine ? t.PRIX_VENTE : t.PRIX_NET) || 0), 0) : 0`,
        Filter: (e) => NumberRangeColumnFilter({...e, isPrice: true}),
        filter: 'between',
        Cell: ({ value }) => (value !== null && value !== undefined && value != "") ? (value.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh") : "-"
      },
      {
        Header: "Avance",
        id: "Avance",
        accessor: row => row.chargeVentes?.reduce((e, t) => e + ((t.isAssLine ? t.vente?.contrat_encaissements : t.contrat_encaissements)?.filter(n => !t.isAssLine || n.ID_ASS == t.id).reduce((e, t) => {return t.PART ? e + t.PART : e}, 0) || 0), 0) || 0,
        customExportDisplay: `$.chargeVentes ? $.chargeVentes.reduce((e, t) => e + ((t.isAssLine ? (t.vente ? t.vente.contrat_encaissements : undefined) : t.contrat_encaissements)?.filter(n => !t.isAssLine || n.ID_ASS == t.id).reduce((e, t) => {return t.PART ? e + t.PART : e}, 0) || 0), 0) : 0`,
        Filter: (e) => NumberRangeColumnFilter({...e, isPrice: true}),
        filter: 'between',
        Cell: ({ value, row, columns }) => {
          const prixNet = row.original.chargeVentes?.reduce((e, t) => e + ((t.isAssLine ? t.PRIX_VENTE : t.PRIX_NET) || 0), 0) || 0;
          return value ? (<>
            {value.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} Dh&nbsp;
            {prixNet ? <span className="encPercent" style={{color: "hsl(" + (Math.ceil((value * 100) / prixNet) * 1.2).toString(10) + ", 100%, 50%)"}}>({Math.ceil((value * 100) / prixNet)}%)</span> : null}
          </>) : "-"
        }
      },
      {
        Header: "Reliquat",
        id: "Reliquat",
        accessor: row => (row.chargeVentes?.reduce((e, t) => e + ((t.isAssLine ? t.PRIX_VENTE : t.PRIX_NET) || 0), 0) || 0) - (row.chargeVentes?.reduce((e, t) => e + ((t.isAssLine ? t.vente?.contrat_encaissements : t.contrat_encaissements)?.filter(n => !t.isAssLine || n.ID_ASS == t.id).reduce((e, t) => {return t.PART ? e + t.PART : e}, 0) || 0), 0) || 0),
        customExportDisplay: `($.chargeVentes ? $.chargeVentes.reduce((e, t) => e + ((t.isAssLine ? t.PRIX_VENTE : t.PRIX_NET) || 0), 0) : 0) - ($.chargeVentes ? $.chargeVentes.reduce((e, t) => e + ((t.isAssLine ? (t.vente ? t.vente.contrat_encaissements : undefined) : t.contrat_encaissements)?.filter(n => !t.isAssLine || n.ID_ASS == t.id).reduce((e, t) => {return t.PART ? e + t.PART : e}, 0) || 0), 0) : 0)`,
        Filter: (e) => NumberRangeColumnFilter({...e, isPrice: true}),
        filter: 'between',
        // filter: (rows, id, e) => rows.filter(t => Number(((+t.original[id]) || 0).toFixed(2)).toString().includes((e || "").replace(",", "."))),
        // sortType: (a, b, id, desc) => {
        //   const aValue = a.original.isAssLine ? a.original.PRIX_VENTE : a.original.PRIX_NET;
        //   const bValue = b.original.isAssLine ? b.original.PRIX_VENTE : b.original.PRIX_NET;
        //   return (aValue ? Number(aValue) : 0) > (bValue ? Number(bValue) : 0) ? 1 : -1
        // },
        Cell: ({ value, row, columns }) => value ? (value.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh") : "-"
      },
      ...(!allAssociationsShown ? [{
        Header: "Somme des Parts Vendues",
        id: "Somme des Parts Vendues",
        accessor: row => row.chargeVentes?.reduce((e, t) => e + (t.isAssLine ? 0 : t.TYPE_VENTE !== "ASSOCIATION" ? t.PRIX_NET : (t.associations || []).reduce((e, t) => {return t.PRIX_VENTE ? e + t.PRIX_VENTE : e}, 0)), 0) || 0,
        customExportDisplay: `$.chargeVentes ? $.chargeVentes.reduce((e, t) => e + (t.isAssLine ? 0 : t.TYPE_VENTE !== "ASSOCIATION" ? t.PRIX_NET : (t.associations || []).reduce((e, t) => {return t.PRIX_VENTE ? e + t.PRIX_VENTE : e}, 0)), 0) : 0`,
        Filter: (e) => NumberRangeColumnFilter({...e, isPrice: true}),
        filter: 'between',
        // filter: (rows, id, e) => rows.filter(t => Number(((+t.original[id]) || 0).toFixed(2)).toString().includes((e || "").replace(",", "."))),
        // sortType: (a, b, id, desc) => {
        //   const aValue = a.original.isAssLine ? a.original.PRIX_VENTE : a.original.PRIX_NET;
        //   const bValue = b.original.isAssLine ? b.original.PRIX_VENTE : b.original.PRIX_NET;
        //   return (aValue ? Number(aValue) : 0) > (bValue ? Number(bValue) : 0) ? 1 : -1
        // },
        Cell: ({ value, row, columns }) => (value !== null && value !== undefined && value != "") ? (<div style={{display: "inline-block"}}>{((value !== null && value !== undefined && value != "") ? (value.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh") : "-")}</div>) : "-"
      }] : []),
      ...(!allAssociationsShown ? [{
        Header: "Avance (Parts)",
        id: "Avance (Parts)",
        accessor: row => row.chargeVentes?.reduce((e, t) => e + (t.isAssLine ? 0 : (t.contrat_encaissements?.reduce((e, t) => {return t.PART ? e + t.PART : e}, 0) || 0)), 0) || 0,
        customExportDisplay: `$.chargeVentes ? $.chargeVentes.reduce((e, t) => e + (t.isAssLine ? 0 : (t.contrat_encaissements ? t.contrat_encaissements.reduce((e, t) => {return t.PART ? e + t.PART : e}, 0) : 0)), 0) : 0`,
        // customExportDisplay: `$.isAssLine ? $.PRIX_VENTE : $.PRIX_NET`,
        Filter: (e) => NumberRangeColumnFilter({...e, isPrice: true}),
        filter: 'between',
        // filter: (rows, id, e) => rows.filter(t => Number(((+t.original[id]) || 0).toFixed(2)).toString().includes((e || "").replace(",", "."))),
        // sortType: (a, b, id, desc) => {
        //   const aValue = a.original.isAssLine ? a.original.PRIX_VENTE : a.original.PRIX_NET;
        //   const bValue = b.original.isAssLine ? b.original.PRIX_VENTE : b.original.PRIX_NET;
        //   return (aValue ? Number(aValue) : 0) > (bValue ? Number(bValue) : 0) ? 1 : -1
        // },
        Cell: ({ value, row, columns }) => {
          const prixNet = row.original.chargeVentes?.reduce((e, t) => e + (t.isAssLine ? 0 : t.TYPE_VENTE !== "ASSOCIATION" ? t.PRIX_NET : (t.associations || []).reduce((e, t) => {return t.PRIX_VENTE ? e + t.PRIX_VENTE : e}, 0)), 0) || 0;
          return value ? (<>
            {value.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} Dh&nbsp;
            {prixNet ? <span className="encPercent" style={{color: "hsl(" + (Math.ceil((value * 100) / prixNet) * 1.2).toString(10) + ", 100%, 50%)"}}>({Math.ceil((value * 100) / prixNet)}%)</span> : null}
          </>) : "-"
        }
      }] : []),
      ...(!allAssociationsShown ? [{
        Header: "Reliquat (Parts)",
        id: "Reliquat (Parts)",
        accessor: row => {
          const prixNet = row.chargeVentes?.reduce((e, t) => e + (t.isAssLine ? 0 : t.TYPE_VENTE !== "ASSOCIATION" ? t.PRIX_NET : (t.associations || []).reduce((e, t) => {return t.PRIX_VENTE ? e + t.PRIX_VENTE : e}, 0)), 0) || 0;
          return (prixNet || 0) - (row.chargeVentes?.reduce((e, t) => e + (t.isAssLine ? 0 : (t.contrat_encaissements?.reduce((e, t) => {return t.PART ? e + t.PART : e}, 0) || 0)), 0) || 0)
        },
        customExportDisplay: `($.chargeVentes ? $.chargeVentes.reduce((e, t) => e + (t.isAssLine ? 0 : t.TYPE_VENTE !== "ASSOCIATION" ? t.PRIX_NET : (t.associations || []).reduce((e, t) => {return t.PRIX_VENTE ? e + t.PRIX_VENTE : e}, 0)), 0) : 0) - ($.chargeVentes ? $.chargeVentes.reduce((e, t) => e + (t.isAssLine ? 0 : (t.contrat_encaissements ? t.contrat_encaissements.reduce((e, t) => {return t.PART ? e + t.PART : e}, 0) : 0)), 0) : 0)`,
        Filter: (e) => NumberRangeColumnFilter({...e, isPrice: true}),
        filter: 'between',
        // filter: (rows, id, e) => rows.filter(t => Number(((+t.original[id]) || 0).toFixed(2)).toString().includes((e || "").replace(",", "."))),
        // sortType: (a, b, id, desc) => {
        //   const aValue = a.original.isAssLine ? a.original.PRIX_VENTE : a.original.PRIX_NET;
        //   const bValue = b.original.isAssLine ? b.original.PRIX_VENTE : b.original.PRIX_NET;
        //   return (aValue ? Number(aValue) : 0) > (bValue ? Number(bValue) : 0) ? 1 : -1
        // },
        Cell: ({ value, row, columns }) => value ? (<>
          {value.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} Dh
        </>) : "-"
      }] : []),
      {
        Header: "Ventes Normales",
        id: "Ventes Normales",
        accessor: row => row.chargeVentes?.filter(e => !e.isAssLine && e.TYPE_VENTE === "UNIQUE").length || 0,
        customExportDisplay: `$.chargeVentes ? $.chargeVentes.filter(e => !e.isAssLine && e.TYPE_VENTE === "UNIQUE").length : 0`,
        Filter: NumberRangeColumnFilter,
        filter: 'between',
      },
      ...(!allAssociationsShown ? [{
        Header: "Associations",
        id: "Associations",
        accessor: row => row.chargeVentes?.filter(e => !e.isAssLine && e.TYPE_VENTE === "ASSOCIATION").length || 0,
        customExportDisplay: `$.chargeVentes ? $.chargeVentes.filter(e => !e.isAssLine && e.TYPE_VENTE === "ASSOCIATION").length : 0`,
        Filter: NumberRangeColumnFilter,
        filter: 'between',
      }] : []),
      ...(allAssociationsShown ? [{
        Header: "Parts d'Association",
        id: "Parts d'Association",
        accessor: row => row.chargeVentes?.filter(e => e.isAssLine).length || 0,
        customExportDisplay: `$.chargeVentes ? $.chargeVentes.filter(e => e.isAssLine).length : 0`,
        Filter: NumberRangeColumnFilter,
        filter: 'between',
      }] : []),
    ], [allAssociationsShown]);

  useEffect(() => {
    // setSkipPageReset(false);
    skipResetRef.current = false;
  }, [ventesData])

  return (
    <div>
      <Container>
        <TableContainer columns={columns} data={ventesData} dataName="recap_par_charge" enableCheckBox={false} isEditable={false} setFilteredRows={setFilteredRows} SubComponent={({ row }) => <span>SubComponent: {row.id}</span>}/>
      </Container>
    </div>
  );
};

const mapStateToProps = (state: IAuthReduxProps) => ({
  auth: state.auth,
  error: state.error
});

export default connect(mapStateToProps, {})(SummaryChargeTable);
